import React from "react";
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";
import { useTranslation } from "react-i18next";
import Container from "Components/Container/Container";

const TableHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 gap-10 text-white font-bold min-w-[1200px] xl:min-w-0">
      {[t("plant_equipment"), t("quantity"), t("remarks")].map(
        (heading, index) => (
          <div
            key={heading}
            className={`
             min-w-[200px] xl:min-w-0`}
          >
            <p className="text-secondary border-b-[3px] border-[#8b8b8b] font-medium text-2xl">
              {heading}
            </p>
          </div>
        )
      )}
    </div>
  );
};

const Resources = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData } = useFetch();
  const { t } = useTranslation();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const result = await fetchData("resourcesandCapabilities");
      setData(result);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <IsLoading />;
  if (isError) return <IsError />;
  if (data) {
    return (
      <main className="bg-black">
        <Container>
          <div className="pt-[10vh]">
            <div className="flex items-center py-14">
              <h1 className="text-secondary text-4xl titles-font">
                {t("nav_resources")}
              </h1>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-24 gap-x-10 gap-y-20">
            {data.map(({ title, text, image }, index) => (
              <div key={index}>
                <img
                  className="w-[10rem] h-[10rem] rounded-full"
                  src={image}
                  alt={title}
                />
                <h2 className="text-secondary text-2xl mt-2 font-bold">
                  {title}
                </h2>
                <div className="border-l-2 border-secondary py-2 mt-1 pl-4">
                  <p
                    className="text-white text-lg"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </div>
              </div>
            ))}
          </div>
        </Container>
      </main>
    );
  }
};

export default Resources;
